const MAX_ENTRIES = 10;
const buffer: string[] = [];

/** Record a recent client-side error (API failure or exception). Newest is kept last. */
export function pushError(message: string): void {
  buffer.push(message);
  if (buffer.length > MAX_ENTRIES) {
    buffer.splice(0, buffer.length - MAX_ENTRIES);
  }
}

/** Returns a snapshot of recent errors, oldest first. */
export function getRecentErrors(): string[] {
  return [...buffer];
}

/** Clears the buffer (used by tests). */
export function clearRecentErrors(): void {
  buffer.length = 0;
}
